module.exports = {
    form: {
        resetBtn: "重置",
        confirmBtn: "确定",
        cancelBtn: "取消",
        formTitle: "编辑",
        formValidateErr: "请按提示检查输入项",
        pleaseInput: "请输入",
        submitSuccess: "提交成功！",
        submitErr: "提交失敗！原因："
    },

    adminBase: {
        addBtn: "新增",
        searchBtn: "搜索",
        edit: "编辑",
        delete: "删除"
    },

    uploader:{
        text:"选择文件上传",
        uploaderPhoto:"上传图片",
        tips:'粘贴网络图片地址',
        addText:"添加",
        tips2:"将附件拖到此处，或<em>点击上传</em>",
    },
    table: {
        operation: "操作"
    }
}